export const SCOPE = 'learning-page';
